import React, { useMemo } from 'react';
import { Archive, RotateCcw, Trash2, FileText } from 'lucide-react';
import { PropertyCategoryView } from '../components/properties/PropertyCategoryView';
import { useProperties } from '../hooks/useProperties';
import { Button } from '../components/ui/Button';
import { Counter } from '../components/ui/Counter';
import { useNavigate } from 'react-router-dom';

export const ArchivedProperties: React.FC = () => {
  const { getPropertiesByStatus, isLoading, updateProperty, deleteProperty } = useProperties();
  const navigate = useNavigate();

  const archivedProperties = useMemo(
    () => getPropertiesByStatus('archived'),
    [getPropertiesByStatus]
  );

  const handleGenerateReport = () => {
    // TODO: Implémenter la génération de rapport des biens archivés
    console.log('Générer rapport des biens archivés');
  };
  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="h-[200px] animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700"
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-3">
              <Archive className="h-8 w-8 text-gray-500" />
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                Biens archivés
              </h1>
            </div>
            <Counter 
              count={archivedProperties.length} 
              label={archivedProperties.length > 1 ? "biens archivés" : "bien archivé"}
              variant="default"
            />
          </div>
          <Button 
            variant="secondary"
            onClick={handleGenerateReport}
            className="flex items-center gap-2"
          >
            <FileText className="h-5 w-5" />
            Rapport des archives
          </Button>
        </div>

        {archivedProperties.length === 0 ? (
          <div className="rounded-lg border-2 border-dashed border-gray-300 p-8 text-center dark:border-gray-700">
            <Archive className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">
              Aucun bien archivé
            </h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              Les biens que vous archivez apparaîtront ici
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="rounded-lg bg-yellow-50 border border-yellow-200 p-4 dark:bg-yellow-900/20 dark:border-yellow-800">
              <div className="flex items-center gap-2">
                <Archive className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
                <h3 className="font-medium text-yellow-800 dark:text-yellow-200">
                  Biens archivés
                </h3>
              </div>
              <p className="mt-1 text-sm text-yellow-700 dark:text-yellow-300">
                Ces biens ont été retirés du marché. Vous pouvez les réactiver ou les supprimer définitivement.
              </p>
            </div>

            <PropertyCategoryView
              title=""
              properties={archivedProperties}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </div>
  );
};